<template>
  <div class="blueTitle">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "blueTitle",
    // props: {
    //   title: {type: String}
    // }
  }
</script>

<style scoped lang="less">
  .blueTitle {
    background: url("../assets/img/pc/common/blueTitle.png");
    background-repeat: no-repeat;
    text-align: left;
    padding-left: 2rem;
    color: #fff;
    width: 7rem;
    margin:auto;
    margin-bottom: 2rem;
  }
</style>
